import { useState } from "react";

import { Button, Icon, Modal } from "@web-app/components";

export default function DeleteModal({
  isBothIndividualAndRoutedOrderSelected,
  isFullRouteSelected,
  isRoutedOrderWithinRouteSelected,
  onClose,
  onDelete,
}: {
  isBothIndividualAndRoutedOrderSelected: boolean;
  isFullRouteSelected: boolean;
  isRoutedOrderWithinRouteSelected: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const onConfirm = async () => {
    try {
      setIsLoading(true);
      await onDelete();
      setIsLoading(false);
      onClose();
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={
        <>
          <Icon name="circleExclamation" className=" text-red-600 mr-2" />
          Delete Orders
        </>
      }
      isOpen={true}
      onClose={onClose}
      noClose={true}
      width={400}
      actionsAlign="end"
      actions={[
        <Button plain onClick={onClose}>
          Cancel
        </Button>,
        <Button
          type="button"
          isLoading={isLoading}
          onClick={onConfirm}
          className="bg-red-600 hover:bg-red-700 text-white"
        >
          Yes, Delete
        </Button>,
      ]}
    >
      <p className="text-sm font-normal leading-5 p-3">
        {isBothIndividualAndRoutedOrderSelected
          ? "One or more selected orders are part of a route. Are you sure you want to delete all orders? "
          : isRoutedOrderWithinRouteSelected && !isFullRouteSelected
            ? "Selected orders are part of a route. Deleting may impact route structure. Proceed?"
            : isRoutedOrderWithinRouteSelected && isFullRouteSelected
              ? "Are you sure you want to delete this route?"
              : "Are you sure you want to delete these orders?"}
      </p>
    </Modal>
  );
}
